export default __webpack_public_path__ + "static/media/parrilla.cd0b0c83.svg";